export default __webpack_public_path__ + "999acf9f205299c6c611b55f372dce3c.png";